import { Routes } from "@angular/router";

import { publicGuard } from "@core/guards/public.guard";

import { LoginRoutesConstants } from "./login.routes.constants";

export const loginRoutes: Routes = [
  {
    path: LoginRoutesConstants.AUTH_CALLBACK,
    canActivate: [publicGuard],
    loadComponent: () => import("@login/components/callback/auth-callback.component").then((m) => m.AuthCallbackComponent),
    title: "Auth Callback"
  },
  {
    path: LoginRoutesConstants.SIGNUP,
    canActivate: [publicGuard],
    loadComponent: () => import("@login/components/signup/signup.component").then((m) => m.SignupComponent),
    title: "Sign up"
  },
  {
    path: LoginRoutesConstants.LOGIN,
    canActivate: [publicGuard],
    loadComponent: () => import("@login/components/login/login.component").then((m) => m.LoginComponent),
    title: "Sign in"
  },
  {
    path: LoginRoutesConstants.RESET_PASSWORD,
    canActivate: [publicGuard],
    loadComponent: () =>
      import("@login/components/reset-password/reset-password.component").then((m) => m.ResetPasswordComponent),
    title: "Reset Password"
  },
  {
    path: LoginRoutesConstants.VERIFY_EMAIL,
    canActivate: [publicGuard],
    loadComponent: () => import("@login/components/verify-email/verify-email.component").then((m) => m.VerifyEmailComponent),
    title: "Verify Email"
  },
  {
    path: LoginRoutesConstants.REGISTER,
    canActivate: [publicGuard],
    loadComponent: () => import("@login/components/register/register.component").then((m) => m.RegisterComponent),
    title: "Register"
  },
  {
    path: LoginRoutesConstants.ERROR,
    canActivate: [publicGuard],
    loadComponent: () => import("@login/components/login-error/login-error.component").then((m) => m.LoginErrorComponent),
    title: "Login Error"
  },
  {
    path: LoginRoutesConstants.TERMS,
    loadComponent: () => import("@login/components/terms/terms.component").then((m) => m.TermsComponent),
    title: "Terms of Service"
  },
  {
    path: LoginRoutesConstants.PRIVACY_POLICY,
    loadComponent: () =>
      import("@login/components/privacy-policy/privacy-policy.component").then((m) => m.PrivacyPolicyComponent),
    title: "Privacy Policy"
  }
];
